/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkClaimOrganizationRequest
 */
export interface LinkClaimOrganizationRequest {
    /**
     * 
     * @type {number}
     * @memberof LinkClaimOrganizationRequest
     */
    organizationId: number;
    /**
     * 
     * @type {string}
     * @memberof LinkClaimOrganizationRequest
     */
    role: string;
    /**
     * 
     * @type {string}
     * @memberof LinkClaimOrganizationRequest
     */
    notes?: string | null;
}

/**
 * Check if a given object implements the LinkClaimOrganizationRequest interface.
 */
export function instanceOfLinkClaimOrganizationRequest(value: object): value is LinkClaimOrganizationRequest {
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function LinkClaimOrganizationRequestFromJSON(json: any): LinkClaimOrganizationRequest {
    return LinkClaimOrganizationRequestFromJSONTyped(json, false);
}

export function LinkClaimOrganizationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkClaimOrganizationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationId': json['organizationId'],
        'role': json['role'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function LinkClaimOrganizationRequestToJSON(json: any): LinkClaimOrganizationRequest {
    return LinkClaimOrganizationRequestToJSONTyped(json, false);
}

export function LinkClaimOrganizationRequestToJSONTyped(value?: LinkClaimOrganizationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organizationId': value['organizationId'],
        'role': value['role'],
        'notes': value['notes'],
    };
}

